export default __webpack_public_path__ + "static/media/image 4.cd19b635.png";